const TabTag = () => {
   return (
      <div className="col-sm-12 p-none">
         <div className="box">
            <div className="content-child">
               <div className="main-content content t0">
                  <div className="pd-all-20 cuf-section">
                     <h5 className="mb20 clearfix"><span className="pull-left text-bigger mt8">Tag</span>
                        <div className="click-render-container pull-right click-render-bulk-action inline-block ml10">
                           <a
                              className="btn btn-default text-smaller" style={{
                                 padding: '10px 12px',
                              }}>
                              <span
                                 style={{
                                    position: 'relative',
                                    fontSize: 14,
                                    color: '#3d4f6e',
                                    fontWeight: 600,
                                    lineHeight: '14px',
                                    height: 36,
                                 }}>
                                 + Thêm Tag Mới
                              </span>
                           </a>
                        </div>
                     </h5>
                     <div>
                        <div className="">
                           <div className="table-wrapper scroll-light">
                              <table className="app-v2-table ">
                                 <thead className="app-v2-table-thead">
                                    <tr className="app-v2-table-tr">
                                       <th className="app-v2-table-th" style={{ width: 330 }}>Tên</th>
                                       <th className="app-v2-table-th text-right-i" style={{ width: 100 }}></th>
                                    </tr>
                                 </thead>
                                 <tbody className="app-v2-table-tbody">
                                    <tr className="pointer app-v2-table-tr">
                                       <td className="text-left app-v2-table-td"><span>KH - NV A</span></td>
                                       <td className="text-right-i app-v2-table-td"><a><i><svg ariaHidden="true" focusable="false"
                                          dataprefix="far" dataicon="trash-alt"
                                          className="svg-inline--fa fa-trash-alt fa-w-14 " role="img"
                                          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: 12 }}>
                                          <path fill="currentColor"
                                             d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z">
                                          </path>
                                       </svg></i></a>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default TabTag;